import { RouteConfig } from 'vue-router';
import ProductInspections from './pages/ProductInspections.vue';
import ReportedProductInspections from './pages/ReportedProductInspections.vue';
import { PermissionTypeEnum } from '@/libs/Api';

export default [
    {
        path: '/:tenantId/product-inspections',
        name: 'ProductInspections',
        component: ProductInspections,
        props: (route) => ({ tenantId: route.params.tenantId }),
        meta: {
            permissions: [PermissionTypeEnum.PerformProductInspection],
            checkLicence: true,
            title: 'menu.productInspection',
        },
    },
    {
        path: '/:tenantId/reported-product-inspections',
        name: 'ReportedProductInspection',
        component: ReportedProductInspections,
        props: (route) => ({ tenantId: route.params.tenantId }),
        meta: {
            permissions: [PermissionTypeEnum.ProductInspections, PermissionTypeEnum.MistakeCorrection],
            checkLicence: true,
            title: 'menu.reportedProductInspection',
        },
    },
] as RouteConfig[];
